import { render, staticRenderFns } from "./r-block-wrap.vue?vue&type=template&id=107d958c&scoped=true&"
import script from "./r-block-wrap.vue?vue&type=script&lang=ts&"
export * from "./r-block-wrap.vue?vue&type=script&lang=ts&"
import style0 from "./r-block-wrap.vue?vue&type=style&index=0&id=107d958c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d958c",
  null
  
)

export default component.exports